module.exports = __webpack_public_path__ + "media/Disneys-Mulan-Official-Trailer.37e4153f.mp4";